<template>
    <div class="interface-config-box">
        <div
            class="interface-config-wrapper"
        >
            <v-page-header :title="$t('接口配置')" />
            <v-tabs v-model="tabValue">
                <Tab
                    :value="1"
                    @before-change="handleBeforeChange"
                >
                    {{ $t('通用鉴权配置信息') }}
                    </Tab>
                <Tab
                    :value="2"
                    @before-change="handleBeforeChange"
                >
                    {{ $t('微软鉴权配置信息') }}
                </Tab>
            </v-tabs>
            <v-page-header
                :title="$t('配置信息填写')"
                level="section"
            />
            <ConfigForm
                v-if="tabValue === 1"
                ref="configForm"
                @update:edit="val => configEdit = val"
            />
            <MicrosoftAuth
                v-if="tabValue === 2"
                ref="microsoftAuth"
                @update:edit="val => microsoftAuthEdit = val"
            />
        </div>
    </div>
</template>
<script>
import ConfigForm from './components/configForm/index.vue';
import MicrosoftAuth from './components/microsoftAuth/index.vue';
import Tab from '@/components/tab/index';

const TAB_COMMON = 1;
const TAB_MICROSOFT = 2;

export default {
    name: 'InterfaceConfig',
    components: {
        ConfigForm,
        MicrosoftAuth,
        Tab,
    },
    data() {
        return {
            tabValue: 1,
            configEdit: false,
            microsoftAuthEdit: false,
        };
    },

    methods: {
        handleBeforeChange(newVal, callback) {
            if (newVal === this.tabValue) {
                return;
            }

            if (newVal === TAB_COMMON && this.tabValue === TAB_MICROSOFT) {
                if (this.microsoftAuthEdit) {
                    this.$refs?.microsoftAuth?.showConfirmDialog(callback);
                } else {
                    callback(true);
                }
            }
            if (newVal === TAB_MICROSOFT && this.tabValue === TAB_COMMON) {
                if (this.configEdit) {
                    this.$refs?.configForm?.showConfirmDialog(callback);
                } else {
                    callback(true);
                }
            }
        },
    },
};
</script>
<style lang="less" scoped>
.interface-config-box {
    margin-bottom: 73px;
}
</style>

<style lang="less">
.auth-dialog {
    .v-dialog__title {
        margin-bottom: 56px;
    }
}
</style>
